// Generated by CoffeeScript 2.7.0
var CalculationMixin;

export default CalculationMixin = {
  computed: {
    valuePresent: function() {
      return this.value !== void 0 && this.value !== null;
    },
    valueForCalculation: function() {
      return {
        type: 'Function',
        value: this.field.data.execed_js
      };
    }
  },
  methods: {
    _initDefaultEntries: function(entries) {
      return entries[0] || {};
    },
    _parseEntriesToValue: function(entry) {
      return this.value = entry.value;
    },
    _parseValueToEntries: function() {
      return [];
    }
  }
};
